var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',_vm._b({attrs:{"min-width":100,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"small":_vm.small,"icon":""}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"small":_vm.small}},[_vm._v("more_vert")])],1)]}}])},'v-menu',_vm.$props,false),[_c('v-list',{attrs:{"dense":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }